import React, { Fragment, useState } from 'react';
import './Explore.css';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import firebase from "firebase/app";
// import {authentication} from '../../../config/firebaseConfig';
// import { signInWithPopup, GoogleAuthProvider, signInWithPhoneNumber, createUserWithEmailAndPassword, EmailAuthProvider } from "firebase/auth";
// import {RecaptchaVerifier } from "firebase/auth";
// import { useDispatch } from 'react-redux';
// import { currentUser } from '../../../redux/actions/fbAuthActions';


function Explore() {

  const [isHovered, setIsHovered] = useState(false);

  const handleHoverSelection = () => {
    setIsHovered(true);
    console.log('hovered')
  }

  const handleLeaveSelection = () => {
    setIsHovered(false);
    console.log('hovered')
  }




  
  return (
    <Fragment>
      <div className='bg-white'>
        <section className='flex gap-8 w-[90dvw] mx-auto mt-20 h-[680px]'>
          <div className='w-[500px]'>
            <p className='mb-2 text-5xl font-bold text-blue-500'>Exploring the Treasures of Odisha</p>
            <p className='text-blue-400'>Odisha, a land of rich culture and heritage, offers a mesmerizing journey through its ancient temples, pristine beaches, and vibrant festivals. From the sacred city of Puri, home to the world-famous Jagannath Temple, to the architectural marvels of Konark and Bhubaneswar, the state is a treasure trove of history. Its lush green forests and wildlife sanctuaries provide a haven for nature lovers. Odisha's unique crafts, tribal arts, and delectable cuisine add to its allure, making it a destination worth exploring. Discover the soul of India in Odisha, where tradition meets tranquility.</p>
          </div>
        <div className="h-[600px] w-full flex justify-center gap-8 items-end bg-[url('https://www.tanzabooks.com/static/media/butterfly.21c9fe43da92365f12ea.png')] bg-contain bg-center bg-no-repeat">
        <div 
  className="w-72 h-52 rounded-[35%] bg-blue-50 shadow-xl border-blue-600 border-[2px]" 
  style={{
    backgroundImage: `
      repeating-linear-gradient(
        45deg, 
        rgba(255, 255, 255, 0.1) 0px, 
        rgba(255, 255, 255, 0.1) 1px, 
        rgba(0, 0, 0, 0.05) 1px, 
        rgba(0, 0, 0, 0.05) 2px
      )
    `,
    backgroundSize: '100%',
    backgroundBlendMode: 'overlay',
  }}
></div>

        <div className='w-72 h-52 rounded-[35%] bg-blue-50 shadow-xl border-blue-600 border-[2px]'></div>

          
          </div>
        </section>
        
      </div>
    </Fragment>
  );
}

export default Explore;